/*
 * @Descripttion:
 * @version:
 * @Author: susj
 * @Date: 2020-09-11 09:19:19
 * @LastEditors: susj
 * @LastEditTime: 2020-09-14 17:12:47
 */
/**
 * 引入UI库使用
 */

import Vue from 'vue';

/**
 * 完整引入
 */

import Antd from 'ant-design-vue';
// import 'ant-design-vue/dist/antd.css';

import 'ant-design-vue/dist/antd.less';

Vue.use(Antd);

/**
 * 按需引用
 * 同时需要配置文件 babel.config.js
 */

// import {
//   Modal,
//   notification,
//   message,
//   Button,
// } from 'ant-design-vue';

// Vue.prototype.$message = message;
// Vue.prototype.$notification = notification;
// Vue.prototype.$info = Modal.info;
// Vue.prototype.$success = Modal.success;
// Vue.prototype.$error = Modal.error;
// Vue.prototype.$warning = Modal.warning;
// Vue.prototype.$confirm = Modal.confirm;

// Vue.use(Button);
